/**
 * Module dependencies.
 */

import { DescriptionWrapper } from '../products/products.style';
import { JSX, useMemo } from 'react';
import {
  StyledDescription,
  StyledTitle,
} from '../catalog-introduction/catalog-introduction.style';

import { useTranslation } from 'next-i18next';

/**
 * `Props` type.
 */

type Props = {
  product: any;
};

/**
 * Export `ProductInformation` component.
 */

export function ProductInformation({ product }: Props): JSX.Element {
  const { i18n } = useTranslation();
  const lang = i18n.language;
  const { description, title } = useMemo(() => {
    return {
      description: product.description[lang],
      title: product.name[lang],
    };
  }, [product.description, product.name, lang]);

  return (
    <>
      <StyledTitle center>{title}</StyledTitle>

      <DescriptionWrapper>
        <StyledDescription>{description}</StyledDescription>
      </DescriptionWrapper>
    </>
  );
}
